module.exports = __webpack_public_path__ + "static/media/plugG3.42f62532.png";